<template>
  <form-group :validator="v" :label="$t('Mobile')">
    <input
      type="number"
      class="input"
      v-model="mobileNo"
      :placeholder="$t('enterMobileNumber')"
      @input="v.$touch()"
    />
  </form-group>
</template>

<script>
export default {
  props: {
    value: {
      type: String,
      default: ""
    },

    v: {
      type: Object,
      required: true
    }
  },

  computed: {
    mobileNo: {
      get() {
        return this.value;
      },

      set(value) {
        this.$emit("input", value);
      }
    }
  }
};
</script>
